'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Text = require('../Text/Text');

var _Text2 = _interopRequireDefault(_Text);

var _Avatar = require('material-ui/Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

var _List = require('material-ui/List');

var _Card = require('material-ui/Card');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO : testi bianchi (wrappare questo elemento in un div?)

var backgroundNone = {
  background: 'none'
};

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundImage = _props.backgroundImage,
          username = _props.username,
          avatar = _props.avatar,
          email = _props.email;

      return _react2.default.createElement(
        _Card.Card,
        null,
        _react2.default.createElement(
          _Card.CardMedia,
          {
            overlay: _react2.default.createElement(
              _List.List,
              { style: backgroundNone },
              _react2.default.createElement(_List.ListItem, {
                leftAvatar: _react2.default.createElement(_Avatar2.default, avatar),
                disabled: true
              }),
              _react2.default.createElement(_List.ListItem, {
                primaryText: _react2.default.createElement(
                  _Text2.default,
                  { color: '#ffffff' },
                  username
                ),
                secondaryText: _react2.default.createElement(
                  _Text2.default,
                  { color: '#ffffff', alpha: 0.75 },
                  email
                ),
                disabled: true
              })
            ),
            overlayContentStyle: backgroundNone
          },
          _react2.default.createElement('img', { src: backgroundImage })
        )
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  backgroundImage: _react2.default.PropTypes.string,
  username: _react2.default.PropTypes.string,
  avatar: _react2.default.PropTypes.object,
  email: _react2.default.PropTypes.string
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/DrawerHeader/DrawerHeader.js
 ** module id = 489
 ** module chunks = 0
 **/